import React from "react";
import ComingSoon from "../Common/ComingSoon.jsx";

const EligibilityPage = () => <ComingSoon />;

export default EligibilityPage;

